/**
 * 课程卡片模式切换
 */
export default {
  modeNames: {
    list: '列表模式',
    card: '卡片模式',
  },
}
